import React, { useState } from "react";
import Specs from "./specs";
import Downloads from "./downloads";
import { blocks } from "../../Dispatch";
import SlideOver from "../../_components/slide_over/SlideOver";

export const MenuList = () => {
  const [showSlideOver, setSlideOver] = useState(false);
  const [content, setContent] = useState();
  const [title, setTitle] = useState("Menu");

  const handleClick = () => {
    setSlideOver(true);
  };
  const handleScrollTo = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute("href");
    const location = document.querySelector(target).offsetTop;

    window.scrollTo({
      left: 0,
      top: location - 40,
    });
  };

  return (
    <>
      <SlideOver
        open={showSlideOver}
        setOpen={setSlideOver}
        title={title}
        content={content}
      />
      <ul className="font-normal text-lg text-gray-900 cursor-pointer">
        <li
          className="py-3 border-b-2 border-x-gray-700 block md:hidden"
          onClick={() => {
            window.open("https://anthemav.com", "_blank");
          }}
        >
          Explore Anthem
        </li>
        <li
          className="py-3 border-b-2 border-x-gray-700 block md:hidden"
          onClick={() => {
            window.open("https://anthemarc.com", "_blank");
          }}
        >
          ARC
        </li>
        <li
          className="py-3 border-b-2 border-x-gray-700 block md:hidden"
          onClick={() => {
            window.open("https://www.anthemav.com/locator/index.php", "_blank");
          }}
        >
          Find a Dealer
        </li>
        <li
          className="py-3 border-b-2 border-x-gray-700"
          onClick={() => {
            setTitle("AVM 90 Downloads");
            setContent(<Downloads />);
            handleClick();
          }}
        >
          Downloads
        </li>
        <li
          className="py-3 border-b-2 border-x-gray-700"
          onClick={() => {
            setTitle("AVM 90 Specifications");
            setContent(<Specs />);
            handleClick();
          }}
        >
          Specifications
        </li>
        {/* <li className="py-3 border-b-2 border-x-gray-700">
          <a
            target={"_blank"}
            href="https://www.flickr.com/photos/anthemav/albums/72157716544890178"
          >
            Gallery
          </a>
        </li> */}
        {blocks
          .filter((block) => block.ref)
          .map((menu) => (
            <li className="py-3 border-b-2 border-x-gray-700">
              <a href={`#${menu.url}`} key={menu.url} onClick={handleScrollTo}>
                {menu.title}
              </a>
            </li>
          ))}
      </ul>
    </>
  );
};
